export enum EnumReviewSortType {
  NEWEST = "NEWEST",
  HIGHEST = "HIGHEST",
  LOWEST = "LOWEST",
}

export enum EnumReviewType {
  WEDDINGBOOK_REVIEW = "WEDDINGBOOK_REVIEW",
  BLOG_REVIEW = "BLOG_REVIEW",
}

export interface IReqPartnerReviewListParams {
  fetchStart: number;
  fetchSize: number;
  sortType?: string;
  partnerUuid: string;
  filterType?: string | null;
}

export interface IReqPartnerReviewDetailParams {
  reviewId: number;
  reviewType: string;
}

export interface IResPartnerReviewItem {
  reviewId: number;
  // writerId: number | null;
  customerId: number | null;
  customerUuid: string | null;
  writerName: string;
  reviewType: string;
  content: string;
  images: string[];
  rating: number;
  regTsp: string;
  reviewTagName: string | null;
  reviewTag: string;
  partner: {
    uuid: string;
    type: number;
    image: string | null;
    name: string;
  };
  communityUuid: string;
  isMyReview: boolean;
  blogReviewUrl: string | null;
  isBan: boolean;
}

export interface IResPartnerAutoCompleteItem {
  partnerId: number;
  partnerUuid: string;
  partnerName: string;
  thumbnailUrl: string | null;
  partnerType: number;
  mainRegion: string;
  subRegion: string;
}

export interface IResPartnerInfoForReview {
  id: number;
  uuid: string;
  type: number;
  name: string;
  tel: string;
  email: string;
  state: number;
  modTsp: string;
  regTsp: string;
  content: string;
  logoUrl: string;
  coverUrl: string;
}

export type SelectedTag =
  | "홀 투어 다녀왔어요"
  | "여기서 결혼했어요"
  | "하객 리뷰"
  | "상담 받았어요"
  | "계약했어요";
